<template>
  <div class="tips">
    <img src="../../img/提示.png" alt="" class="tips__left">
    <div class="tips__right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tips'
}
</script>

<style lang="scss" scoped>
.tips{
  display: flex;
  align-items: center;
  background-color: #fdf2cc;
  box-sizing: border-box;
  width: 100%;
  padding: 4px 2px;
  margin: 2px auto;
  border-radius: 6px;
  &__left{
    width: 20px;
    height: 20px;
    margin: 0 5px;
  }
  &__right{
    line-height: 20px;
    font-size: 12px;
  }
}
</style>
